import React from 'react'

function defaultGetScrollerAPI() {
  return {
    refresh: () => {},
    getScrollDimensions: () => {},
    scrollElementIntoView: () => {},
    scrollElementIntoViewIfNeeded: () => {},
    scrollToX: () => {},
    scrollToY: () => {},
    scrollToBottom: () => {},
  }
}

export default React.createContext(defaultGetScrollerAPI)
